module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMAAAADABAMAAACg8nE0AAAAG1BMVEUAAAD////////////////////////////////rTT7CAAAACHRSTlMAGTIzNIDu74SmurEAAADkSURBVHgB7dvBGcFQAARhoI+UoJQcc0ySEigBtmvgFQAGmGngfT8IrNGdmZmZmZmZzWv4gGYDAxKW0CQbGMARCgAjFABHKACMUAAcoQBAQgEUAgtIOhiwrWBAL0CAgF8GCBAgQMACBgzfDRAgQMASBuy+GyBAgIDbuxFwezQgNCA0IDQgNCA0gD+Av4loAv8wpQn8SwVN4F+ubySsRvwlk75m/gpBggQJA03YvoggQYKEHidU/0aQIEGCBAkSJHQ0oebHlAwBAACDVmCSi4+K+Vk0P+zmp+n8uJ7/e4CZmZmZmdkBN3Fu08WkTuIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow_back.png
// module id = 458
// module chunks = 0